import { LeasingCalculatorData } from 'modules/leasingCalculator/components/common/LeasingCalculatorData';
import { LeasingOfferDetails } from 'modules/types/LeasingOffer';
import { PagingParams } from 'modules/types/PagingParams';
import { pagingToParams } from 'modules/utils';
import { LeasingCalculatorProductSelectionData } from 'modules/types/LeasingCalculator';
import { getParticipationPropertyByLeasingType } from 'modules/leasingCalculator/components/common/helper';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const startLeasingCalculator = async () => {
  const response = await axiosInstance.get<boolean>(
    `${REACT_APP_API_SERVER_URL}/api/leasing-calculator/start`,
  );

  return response.data;
};

export const fetchPremadeProducts = async (
  params: PagingParams,
  calculatorData: LeasingCalculatorData,
) => {
  const participationProperty = getParticipationPropertyByLeasingType(
    calculatorData?.leasingType?.name,
  );
  const body = {
    ...calculatorData,
    participationAmount:
      calculatorData?.[
        `${participationProperty}` as keyof typeof calculatorData
      ],
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/leasing-calculator/premade-products?${pagingToParams(
      params,
    )}`,
    body,
  );

  const {
    data: { content, totalPages },
  } = response;

  return {
    premadeProducts: content,
    totalPageCount: totalPages,
    page: params.page,
  };
};

export const submitProductSelectionData = async (
  productSelectionData: LeasingCalculatorProductSelectionData,
) => {
  const response = await axiosInstance.post<LeasingOfferDetails>(
    `${REACT_APP_API_SERVER_URL}/api/leasing-calculator/product-selection`,
    productSelectionData,
  );

  return response.data;
};

export const requestFinancing = async (offerNumber: number) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/leasing-calculator/request-financing/${offerNumber}`,
  );

  return response.status === 200 || response.status === 201;
};
